import type {
  OtherProductItem,
  OtherProducts,
  SendDetailProductList,
  TransactionDetails,
} from '@/api/send_detail/model/sendMailModel'

import { ReceivedStatus } from '@/views/sendMail/types'
import defaultTransactionDetails from './defaultTransactionDetails'

export interface State {
  showProductAddModal: boolean
  transactionDetails: TransactionDetails
  receiveStatus: ReceivedStatus
  product_list: SendDetailProductList
  otherProducts: OtherProducts
  originalOtherProducts: OtherProducts
  total_count: number
  current_page: number
  page_size: number
  showOtherAddSubmitModal: boolean
  selectedOtherProduct: OtherProductItem
}

const state = (): State => ({
  showProductAddModal: false,
  transactionDetails: defaultTransactionDetails,
  receiveStatus: ReceivedStatus.NO_VALUE,
  product_list: [],
  otherProducts: [],
  originalOtherProducts: [],
  total_count: -1,
  current_page: 1,
  page_size: 1000,
  showOtherAddSubmitModal: false,
  selectedOtherProduct: {} as OtherProductItem,
})

export default state
